(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["editorial-story"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-video-toggle]').forEach((button) => {
    if (button.dataset.videoReady === 'true') return;
    const video = document.getElementById(button.getAttribute('aria-controls'));
    if (!video) return;
    button.dataset.videoReady = 'true';
    const syncLabel = () => {
      button.textContent = video.paused ? button.dataset.playLabel : button.dataset.pauseLabel;
    };
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) video.pause();
    button.addEventListener('click', () => {
      if (video.paused) video.play();
      else video.pause();
    });
    video.addEventListener('play', syncLabel);
    video.addEventListener('pause', syncLabel);
    syncLabel();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["immersive-media"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__immersiveLazyVideoRuntime) return;
    window.__immersiveLazyVideoRuntime = true;
    const selector = '[data-lazy-video-frame]';
    const instances = new WeakMap();
    const motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');

    const mountFrame = (frame) => {
      if (instances.has(frame)) return;
      const video = frame.querySelector('[data-lazy-video]');
      const button = frame.parentElement.querySelector('[data-lazy-video-toggle]');
      if (!video || !button || !video.querySelector('source[data-src]')) return;

      let sourcesLoaded = false;
      let userPaused = false;
      let nearViewport = false;
      let observer;

      const syncLabel = () => {
        button.textContent = video.paused ? button.dataset.playLabel : button.dataset.pauseLabel;
      };
      const loadSources = () => {
        if (sourcesLoaded) return;
        const sources = video.querySelectorAll('source[data-src]');
        if (!sources.length) return;
        sources.forEach((source) => {
          source.src = source.dataset.src;
          source.removeAttribute('data-src');
        });
        sourcesLoaded = true;
        video.load();
      };
      const play = () => {
        if (!sourcesLoaded) loadSources();
        if (!sourcesLoaded) return;
        const playRequest = video.play();
        if (playRequest && typeof playRequest.catch === 'function') playRequest.catch(() => {});
      };
      const pauseForMotionPreference = () => {
        if (motionPreference.matches) video.pause();
        else if (nearViewport && !userPaused) play();
      };
      const onVisibilityChange = () => {
        if (document.hidden) video.pause();
        else if (nearViewport && !userPaused && !motionPreference.matches) play();
      };
      const onButtonClick = () => {
        if (video.paused) {
          userPaused = false;
          play();
        } else {
          userPaused = true;
          video.pause();
        }
      };
      const onPlaying = () => {
        frame.classList.add('is-playing');
        syncLabel();
      };
      const onPause = () => {
        syncLabel();
      };

      button.hidden = false;
      button.addEventListener('click', onButtonClick);
      video.addEventListener('playing', onPlaying);
      video.addEventListener('pause', onPause);
      motionPreference.addEventListener('change', pauseForMotionPreference);
      document.addEventListener('visibilitychange', onVisibilityChange);
      syncLabel();

      if ('IntersectionObserver' in window) {
        observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            nearViewport = entry.isIntersecting;
            if (nearViewport && !motionPreference.matches && !userPaused && !document.hidden) play();
            else video.pause();
          });
        }, { rootMargin: '200px 0px' });
        observer.observe(frame);
      } else if (!motionPreference.matches) {
        nearViewport = true;
        play();
      }

      instances.set(frame, () => {
        if (observer) observer.disconnect();
        button.removeEventListener('click', onButtonClick);
        video.removeEventListener('playing', onPlaying);
        video.removeEventListener('pause', onPause);
        motionPreference.removeEventListener('change', pauseForMotionPreference);
        document.removeEventListener('visibilitychange', onVisibilityChange);
        video.pause();
        frame.classList.remove('is-playing');
        button.hidden = true;
      });
    };

    const mount = (root) => {
      if (root.matches && root.matches(selector)) mountFrame(root);
      root.querySelectorAll(selector).forEach(mountFrame);
    };
    const destroy = (root) => {
      if (root.matches && root.matches(selector)) {
        const cleanup = instances.get(root);
        if (cleanup) cleanup();
        instances.delete(root);
      }
      root.querySelectorAll(selector).forEach((frame) => {
        const cleanup = instances.get(frame);
        if (cleanup) cleanup();
        instances.delete(frame);
      });
    };

    const initialize = () => mount(document);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
    else initialize();
    document.addEventListener('shopify:section:load', (event) => mount(event.target));
    document.addEventListener('shopify:section:unload', (event) => destroy(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ingredient-atlas"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-ingredient-atlas]';
    const instances = new WeakMap();

    const getRoot = (node) => {
      if (!(node instanceof Element)) return null;
      return node.matches(selector) ? node : node.closest(selector) || node.querySelector(selector);
    };

    const mount = (scope) => {
      const roots = [];
      if (scope instanceof Element && scope.matches(selector)) roots.push(scope);
      if (scope.querySelectorAll) roots.push(...scope.querySelectorAll(selector));

      roots.forEach((root) => {
        if (instances.has(root)) return;
        const tabs = [...root.querySelectorAll('[data-atlas-tab]')];
        const panels = [...root.querySelectorAll('[data-atlas-panel]')];
        const tabByPanel = new Map(tabs.map((tab) => [tab.dataset.panelId, tab]));
        const panelByTab = new Map(tabs.map((tab) => [tab, panels.find((panel) => panel.id === tab.dataset.panelId)]));
        const firstTab = tabs[0];
        if (!firstTab || !panelByTab.get(firstTab) || tabs.length !== panels.length) return;

        const controller = new AbortController();
        const animations = new Set();
        const motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        root.dataset.atlasEnhanced = 'true';
        const nav = root.querySelector('.ingredient-atlas__nav');
        if (nav) {
          nav.setAttribute('role', 'tablist');
          nav.setAttribute('aria-orientation', 'horizontal');
        }

        const cancelAnimations = () => {
          animations.forEach((animation) => animation.cancel());
          animations.clear();
        };
        const animate = (element, keyframes, duration) => {
          if (!element || root.dataset.motion !== 'true' || motionQuery.matches || typeof element.animate !== 'function') return;
          const animation = element.animate(keyframes, { duration, easing: 'ease-out', fill: 'both' });
          animations.add(animation);
          animation.addEventListener('finish', () => { animations.delete(animation); animation.cancel(); }, { once: true });
          animation.addEventListener('cancel', () => animations.delete(animation), { once: true });
        };
        const setActive = (tab, shouldAnimate = true, shouldFocus = false) => {
          if (!panelByTab.get(tab)) return;
          cancelAnimations();
          const activeElement = document.activeElement;
          const focusedOutgoingPanel = panels.find((panel) => !panel.hidden && panel.id !== tab.dataset.panelId && panel.contains(activeElement));
          if (focusedOutgoingPanel) tab.focus();
          tabs.forEach((candidate) => {
            const selected = candidate === tab;
            candidate.setAttribute('role', 'tab');
            candidate.setAttribute('aria-controls', candidate.dataset.panelId);
            candidate.setAttribute('aria-selected', String(selected));
            candidate.tabIndex = selected ? 0 : -1;
          });
          panels.forEach((panel) => {
            const selected = panel.id === tab.dataset.panelId;
            const panelTab = tabByPanel.get(panel.id);
            panel.setAttribute('role', 'tabpanel');
            if (panelTab) panel.setAttribute('aria-labelledby', panelTab.id || (panelTab.id = `${panel.id}-tab`));
            panel.tabIndex = 0;
            panel.hidden = !selected;
          });
          if (shouldFocus) tab.focus();
          if (shouldAnimate) {
            const panel = panelByTab.get(tab);
            animate(panel.querySelector('.ingredient-atlas__image'), [{ opacity: 0 }, { opacity: 1 }], 420);
            animate(panel.querySelector('.ingredient-atlas__benefits'), [{ opacity: 0, transform: 'translateY(8px)' }, { opacity: 1, transform: 'translateY(0)' }], 240);
          }
        };

        tabs.forEach((tab) => tab.addEventListener('click', (event) => {
          event.preventDefault();
          setActive(tab, true, false);
        }, { signal: controller.signal }));
        root.addEventListener('keydown', (event) => {
          if (!(event.target instanceof Element)) return;
          const current = event.target.closest('[data-atlas-tab]');
          if (!current) return;
          const index = tabs.indexOf(current);
          let nextIndex = index;
          if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
          else if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
          else if (event.key === 'Home') nextIndex = 0;
          else if (event.key === 'End') nextIndex = tabs.length - 1;
          else if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            setActive(current, true, true);
            return;
          } else return;
          event.preventDefault();
          tabs.forEach((candidate, candidateIndex) => { candidate.tabIndex = candidateIndex === nextIndex ? 0 : -1; });
          tabs[nextIndex].focus();
        }, { signal: controller.signal });

        root.querySelectorAll('[data-atlas-benefit]').forEach((details) => details.addEventListener('toggle', () => {
          if (!details.open || details.closest('[data-atlas-panel]')?.hidden) return;
          animate(details.querySelector('.ingredient-atlas__body'), [{ opacity: 0, transform: 'translateY(3px)' }, { opacity: 1, transform: 'translateY(0)' }], 180);
        }, { signal: controller.signal }));
        const onMotionChange = (event) => { if (event.matches) cancelAnimations(); };
        motionQuery.addEventListener('change', onMotionChange);
        const instance = {
          setActive,
          destroy() {
            controller.abort();
            motionQuery.removeEventListener('change', onMotionChange);
            cancelAnimations();
            root.removeAttribute('data-atlas-enhanced');
            if (nav) {
              nav.removeAttribute('role');
              nav.removeAttribute('aria-orientation');
            }
            tabs.forEach((tab) => {
              tab.removeAttribute('role');
              tab.removeAttribute('aria-controls');
              tab.removeAttribute('aria-selected');
              tab.removeAttribute('tabindex');
            });
            panels.forEach((panel) => {
              panel.removeAttribute('role');
              panel.removeAttribute('aria-labelledby');
              panel.removeAttribute('tabindex');
              panel.hidden = false;
            });
            instances.delete(root);
          }
        };
        instances.set(root, instance);
        setActive(firstTab, false, false);
      });
    };

    const destroyWithin = (scope) => {
      const roots = [];
      if (scope instanceof Element && scope.matches(selector)) roots.push(scope);
      if (scope.querySelectorAll) roots.push(...scope.querySelectorAll(selector));
      roots.forEach((root) => instances.get(root)?.destroy());
    };

    document.addEventListener('shopify:section:load', (event) => mount(event.target));
    document.addEventListener('shopify:section:unload', (event) => destroyWithin(event.target));
    document.addEventListener('shopify:section:select', (event) => {
      const root = getRoot(event.target);
      if (root) instances.get(root)?.setActive([...root.querySelectorAll('[data-atlas-tab]')][0], false, false);
    });
    document.addEventListener('shopify:block:select', (event) => {
      const root = getRoot(event.target);
      const instance = root && instances.get(root);
      if (!instance) return;
      const block = event.target.closest('[data-ingredient-key]');
      if (!block) return;
      const tab = [...root.querySelectorAll('[data-atlas-tab]')].find((item) => item.dataset.ingredientKey === block.dataset.ingredientKey);
      if (tab) instance.setActive(tab, false, false);
      const details = block.matches('details') ? block : block.closest('details');
      if (details) details.open = true;
    });
    mount(document);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  document.querySelectorAll('[data-product-section]').forEach((section) => {
    const form = section.querySelector('[data-product-form]');
    const variantsNode = section.querySelector('[data-product-variants]');
    if (!form || !variantsNode) return;
    const variants = JSON.parse(variantsNode.textContent);
    const idInput = form.querySelector('input[name="id"]');
    const addButton = form.querySelector('button[name="add"]');
    const dynamicCheckout = form.querySelector('[data-dynamic-checkout]');
    const price = section.querySelector('[data-product-price]');
    const selectionError = section.querySelector('[data-product-selection-error]');
    const requestedVariantId = Number(new URLSearchParams(window.location.search).get('variant'));
    const initialVariant = variants.find((item) => item.id === requestedVariantId)
      || variants.find((item) => item.available)
      || variants[0];
    if (idInput && !idInput.value && initialVariant) idInput.value = initialVariant.id;
    const optionFieldsets = Array.from(form.querySelectorAll('fieldset'));
    if (optionFieldsets.length === 0) return;
    form.addEventListener('change', (event) => {
      if (!event.target.matches('input[name^="options["]')) return;
      const selected = optionFieldsets.map((fieldset) => fieldset.querySelector('input:checked')?.value);
      const variant = variants.find((item) => item.options.every((option, index) => option === selected[index]));
      if (!variant) {
        idInput.value = '';
        addButton.disabled = true;
        addButton.textContent = addButton.dataset.soldLabel;
        if (dynamicCheckout) dynamicCheckout.hidden = true;
        if (price) price.hidden = true;
        if (selectionError) selectionError.hidden = false;
        return;
      }
      if (selectionError) selectionError.hidden = true;
      idInput.value = variant.id;
      addButton.disabled = !variant.available;
      addButton.textContent = variant.available ? addButton.dataset.addLabel : addButton.dataset.soldLabel;
      if (dynamicCheckout) dynamicCheckout.hidden = !variant.available;
      if (price && Number.isFinite(Number(variant.price))) {
        price.hidden = false;
        price.textContent = new Intl.NumberFormat(document.documentElement.lang, { style: 'currency', currency: window.Shopify.currency.active }).format(Number(variant.price) / 100);
      }
      const nextUrl = new URL(window.location.href);
      nextUrl.searchParams.set('variant', variant.id);
      history.replaceState(history.state, '', nextUrl);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["skin-quiz"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const instances = new WeakMap();
    const mount = (quiz) => {
      if (instances.has(quiz)) return;
      const form = quiz.querySelector('.skin-quiz__form');
      const show = quiz.querySelector('[data-quiz-show]');
      const results = quiz.querySelector('.skin-quiz__results');
      if (!form || !show || !results) return;
      const controller = new AbortController();
      const signal = controller.signal;
      show.addEventListener('click', () => {
        const selected = form.querySelector('input[name="product_step"]:checked');
        if (!selected) { form.querySelector('input[name="product_step"]')?.focus(); return; }
        form.hidden = true;
        results.querySelectorAll('[data-result]').forEach((result) => { result.hidden = result.dataset.result !== selected.value; });
        results.hidden = false;
        results.focus({ preventScroll: true });
        results.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      }, { signal });
      results.querySelectorAll('[data-quiz-restart]').forEach((button) => button.addEventListener('click', () => {
        form.reset(); results.hidden = true;
        results.querySelectorAll('[data-result]').forEach((result) => { result.hidden = true; });
        form.hidden = false; form.querySelector('input[name="product_step"]')?.focus();
      }, { signal }));
      instances.set(quiz, () => controller.abort());
    };
    const mountAll = (root = document) => root.querySelectorAll('[data-quiz-id]').forEach(mount);
    const unmountAll = (root = document) => root.querySelectorAll('[data-quiz-id]').forEach((quiz) => {
      instances.get(quiz)?.(); instances.delete(quiz);
    });
    mountAll();
    document.addEventListener('shopify:section:load', (event) => mountAll(event.target));
    document.addEventListener('shopify:section:unload', (event) => unmountAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
